
document.addEventListener('DOMContentLoaded', function () {

  const partsBtn = document.querySelectorAll('.js-consultation-modal')
  const closeBtn = document.querySelectorAll('.js-modal-close')

  partsBtn.forEach(function (d) {
    d.addEventListener('click', function () {
      const parts = this.getAttribute('data-parts')
      const wrapper = document.getElementById(parts)
      wrapper.style.display = 'flex'
    })
  })

  closeBtn.forEach(function (d) {
    d.addEventListener('click', function () {
      const wrapper = this.parentNode.parentNode
      wrapper.style.display = 'none'
    })
  })

}) // end of DOMContentLoaded
